// extracted by mini-css-extract-plugin
export default {"wrapper":"hero_wrapper","carousel":"hero_carousel","gallery":"hero_gallery"};